import { atom } from 'jotai';

export const killSwitchesAtom = atom<Record<string, boolean | undefined> | undefined>(undefined);
